var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPin = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mapPin",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 25.1",
    style: {
      enableBackground: "new 0 0 28 25.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.map-pin{fill:#FF9E00;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "map-pin",
    d: "M8.7,2.3c1.4-1.4,3-2.1,5-2.1c1.9,0,3.6,0.7,5,2.1c1.4,1.4,2.1,3,2.1,5c0,1.9-0.7,3.6-2.1,5 c-1.4,1.4-3,2.1-5,2.1c-1.9,0-3.6-0.7-5-2.1c-1.4-1.4-2.1-3-2.1-5C6.6,5.3,7.3,3.7,8.7,2.3z M13.6,3.3c0.1,0,0.2,0,0.3-0.1 C14,3.1,14.1,3,14.1,2.9c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-1.3,0-2.5,0.5-3.4,1.4C9.3,4.8,8.8,5.9,8.8,7.3 c0,0.1,0,0.2,0.1,0.3C9,7.7,9.1,7.7,9.3,7.7c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-1.1,0.4-2,1.2-2.8 C11.6,3.7,12.6,3.3,13.6,3.3z M11.9,15c0.6,0.1,1.2,0.2,1.8,0.2s1.2-0.1,1.8-0.2v9c0,0.2-0.1,0.4-0.3,0.6c-0.2,0.2-0.4,0.3-0.6,0.3 h-1.8c-0.2,0-0.4-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.6V15L11.9,15z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin.c52dcfd2.svg";
export { ForwardRef as ReactComponent };